// Reenvío del código de referido (PM-081) desde el cajón del cliente. Sin base URL de
// promociones no hace la petición: caería en el API del rbac.
import { apiFetch } from '../../client';
import type { components } from './retail-promotions.gen';

export type ReferralCouponResendResponse = components['schemas']['CustomerManualMessageResponse'];

/** El servicio de promociones no tiene base URL en este ambiente. */
export class ReferralCouponServiceNotConfiguredError extends Error {
    constructor() {
        super('El servicio de promociones no está configurado en este ambiente.');
        this.name = 'ReferralCouponServiceNotConfiguredError';
    }
}

/**
 * `publicResendReferralCoupon` — POST /public/customers/{id}/referral-coupon/resend. Encola el SMS
 * con el código vigente. Permiso `retail.promotion.coupon.resend`.
 */
export function resendReferralCoupon(
    retailCustomerId: string,
): Promise<ReferralCouponResendResponse> {
    const baseUrl = (
        import.meta.env.VITE_API_RETAIL_PROMOTIONS_BASE_URL as string | undefined
    )?.trim();
    if (!baseUrl) return Promise.reject(new ReferralCouponServiceNotConfiguredError());
    return apiFetch<ReferralCouponResendResponse>(
        `/public/customers/${encodeURIComponent(retailCustomerId)}/referral-coupon/resend`,
        { method: 'POST', baseUrl },
    );
}
